import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppSidebar } from "@/components/header/app-sidebar";
import Header from "@/components/header/header";
import { SidebarProvider } from "@/components/ui/sidebar";

export const Route = createFileRoute("/_app")({
	component: AppLayoutComponent,
});

function AppLayoutComponent() {
	return (
		<SidebarProvider>
			<AppSidebar />

			<div className="flex flex-col w-full">
				<Header />
				<Outlet />
			</div>
		</SidebarProvider>
	);
}
